import { useTranslation } from 'react-i18next';

interface HiddenAppsBannerProps {
  count: number;
  onRestoreAll: () => void;
}

export function HiddenAppsBanner({ count, onRestoreAll }: HiddenAppsBannerProps) {
  const { t } = useTranslation();
  if (count === 0) return null;

  return (
    <div className="flex items-center justify-between rounded-md border border-amber-200 bg-amber-50 px-4 py-2 text-xs text-amber-900">
      <span>{t('home.hidden.banner', { count })}</span>
      <button
        type="button"
        onClick={onRestoreAll}
        className="rounded-md bg-amber-100 px-3 py-1 text-xs font-medium hover:bg-amber-200"
      >
        {t('home.hidden.restoreAll')}
      </button>
    </div>
  );
}
